import type { DataMapName } from '@wix/thunderbolt-becky-types'
import { pointers } from '@wix/thunderbolt-becky-types'
import { Connections } from './dataNodes/Connections'
import { Behaviors } from './dataNodes/Behaviors'
import { DocumentData } from './dataNodes/DocumentData'
import type { TemplateDataNode } from './dataNodes/utils/dataNodeUtils'
import type { ByRefsisTemplateCompNode } from '../compNodeUtils'
import { RefComponentsTemplateData } from './compNodes/refComponentsTemplateData'
import { ComponentStructureWithSlots } from './compNodes/componentStructureWithSlots'
import { REF_COMPONENTS_TEMPLATE_DATA_ASPECT, COMPONENTS_WITH_SLOTS_ASPECT } from '../constants'

const {
	DATA_MAPS: { CONNECTIONS, BEHAVIORS, DATA },
} = pointers.data

export const templateDataNodes: { [dataMapName in DataMapName]?: TemplateDataNode<any, any, any> } = {
	[CONNECTIONS]: Connections,
	[BEHAVIORS]: Behaviors,
	[DATA]: DocumentData,
}

export const templateCompNodes: Record<string, ByRefsisTemplateCompNode<any, any>> = {
	[REF_COMPONENTS_TEMPLATE_DATA_ASPECT]: RefComponentsTemplateData,
	[COMPONENTS_WITH_SLOTS_ASPECT]: ComponentStructureWithSlots,
}
